import { Component, ChangeDetectionStrategy } from '@angular/core';

interface LineConfig {
  top: string;
  animationName: string;
  animationDuration: string;
}

@Component({
    selector: 'app-background-lines',
    templateUrl: './background-lines.component.html',
    styleUrl: './background-lines.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BackgroundLinesComponent {
  readonly lines: LineConfig[] = Array.from({ length: 20 }, (_, i) => ({
    top: `${i * 5}%`,
    animationName: i % 2 === 0 ? 'slide-left' : 'slide-right',
    animationDuration: `${10 + Math.random() * 20}s`,
  }));
}
